import React, {Component} from 'react'
import {Table, Row, Col, Popconfirm, message, Button, Upload, Icon,Modal,Popover} from 'antd';
import OrderFileComponent from "../../components/bus/order-file"

let orderId;
export default class OrderFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId:"",
        }
    }
    componentDidMount() {
        if(this.props.location.state) {
            orderId = this.props.location.state.orderId;
            this.setState({
                orderId
            })
        }
    }
    render() {


        return (
            <OrderFileComponent {...this.props}/>
        )
    }
}